const enums = {
    variants: ['Active', 'Inactive', 'Locked', 'Created',
        'LeadActive', 'LeadConverted', 'LeadCold', 'LeadLost', 'LeadDuplicate', 'Unavailable'],
};

export default enums;
